import React, { useContext } from "react";
import { AuthContext } from '../contexts/auth';
import NoPermissions from "../authorization/NoPermissions";


const CheckPermissions = ({ permissionsToCheck, children }) => {
    const { profile } = useContext(AuthContext);

    if (profile.customer_type === 'consultant' || profile.customer_type === 'company') {
        return children;
    }

    if (!profile || !profile.employee || !profile.employee.permissions) {
        console.log("No profile or permissions found"); 
        return <NoPermissions />;
    }

    const hasPermission = permissionsToCheck.some(permission =>
        profile.employee.permissions.includes(permission)
    );

    return hasPermission ? children : <NoPermissions />;
};

export default CheckPermissions;
